import type { UserBase } from '@core/account-types';
import { createProviderToken } from '@core/common-legacy';
import type { MentionElement } from '@core/prosemirror-legacy';
import { MentionType } from '@core/prosemirror-legacy';

export const userToMention = (user: UserBase, additionalFields?: any): MentionElement => ({
  id: user.id,
  type: MentionType.User,
  name: `${user.firstName} ${user.lastName}`,
  avatar: user.photoThumbUrl,
  entity: user,
  hasAvatar: user.hasAvatar,
  initials: user.initials,
  ...additionalFields,
});

interface NotesTranslations {
  save: string;
  more: string;
  edit: string;
  pin: string;
  guest: string;
  cancel: string;
  delete: string;
  fileSizeLimitExceeded: string;
  reply: string;
  unpin: string;
  showMoreReplies: string;
  automatedAction: string;
  adminsAreTyping: string;
  adminIsTyping: string;
  deleteTitle: string;
  deleteMessage: string;
  deleteAgreeLabel: string;
  addAttachment: string;
}

export const { provide: provideNotesTranslations, inject: injectNotesTranslations } =
  createProviderToken<NotesTranslations>('NotesTranslations')(false, {
    factory: () => ({
      save: 'app.common.save',
      more: 'app.common.more',
      edit: 'app.common.edit',
      pin: 'app.notes.pin_note',
      guest: 'app.common.guest',
      cancel: 'app.common.cancel',
      delete: 'app.common.delete',
      fileSizeLimitExceeded: 'app.common.errors.file_size_limit_exceeded',
      reply: 'app.notes.reply',
      unpin: 'app.notes.unpin',
      showMoreReplies: 'app.notes.show_more_replies',
      automatedAction: 'app.notes.automated_action',
      adminsAreTyping: 'app.notes.typing_indicator.many_admins_are_typing',
      adminIsTyping: 'app.notes.typing_indicator.admin_is_typing',
      deleteTitle: 'app.candidate.confirmation.delete.title',
      deleteMessage: 'app.candidate.confirmation.delete.message',
      deleteAgreeLabel: 'app.candidate.confirmation.delete.agree_label',
      addAttachment: 'app.candidate.add_attachment',
    }),
  });
